import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/js/Login';
import Signup from './components/js/Signup';
import SignupSuccess from './components/js/SignupSuccess';
import Dashboard from './components/js/Dashboard';
import AdminManagement from './components/js/AdminManagement';
import UserManagement from './components/js/UserManagement';
import InquiryManagement from './components/js/InquiryManagement';
import InquiryDetail from './components/js/InquiryDetail';
import InquiryAnswer from './components/js/InquiryAnswer';
import ProtectedRoute from './components/js/side/ProtectedRoute';
import NoticeManagement from './components/js/NoticeManagement';
import NoticeWrite from './components/js/NoticeWrite';
import NoticeEdit from './components/js/NoticeEdit';
import './App.css';
import DatasetList from './components/js/DatasetList';
import DatasetAdd from './components/js/DatasetAdd';
import AITrainManager from './components/js/AITrainManager';
import VersionManagement from './components/js/VersionManagement';
import LogViewer from './components/js/LogViewer';
import DefaultSongTable from './components/js/DefaultSongTable';
import ServerStatus from './components/js/ServerStatus';
import Intro from './components/js/Intro';

const App = () => {
  // Simple auth check function
  const isAuthenticated = () => {
    return localStorage.getItem('token') !== null;
  };

  return (
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Intro />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/signup-success" element={<SignupSuccess />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/admins"
            element={
              <ProtectedRoute>
                <AdminManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/users"
            element={
              <ProtectedRoute>
                <UserManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/inquirys"
            element={
              <ProtectedRoute>
                <InquiryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/inquirys/:inquiryId"
            element={
              <ProtectedRoute>
                <InquiryDetail />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/inquirys/:inquiryId/answer"
            element={
              <ProtectedRoute>
                <InquiryAnswer />
              </ProtectedRoute>
            }
          />
          
          <Route
            path="/admin/notice"
            element={
              <ProtectedRoute>
                <NoticeManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/notice/write"
            element={
              <ProtectedRoute>
                <NoticeWrite />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/notice/:noticeId"
            element={
              <ProtectedRoute>
                <NoticeWrite />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/notice/:noticeId/edit"
            element={
              <ProtectedRoute>
                <NoticeEdit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ai/dataset"
            element={
              <ProtectedRoute>
                <DatasetList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ai/dataset/add"
            element={
              <ProtectedRoute>
                <DatasetAdd />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ai/train"
            element={
              <ProtectedRoute>
                <AITrainManager />
              </ProtectedRoute>
            }
          />

          <Route
            path="/ai-models/versions"
            element={
              <ProtectedRoute>
                <VersionManagement />
              </ProtectedRoute>
            }
          />

          <Route
            path="/logs"
            element={
              <ProtectedRoute>
                <LogViewer />
              </ProtectedRoute>
            }
          />

          <Route
            path="/songs"
            element={
              <ProtectedRoute>
                <DefaultSongTable />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/server-status"
            element={
              <ProtectedRoute>
                <ServerStatus />
              </ProtectedRoute>
            }
          />

          {/* Catch all route - redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>

        
      </Router>
  );
};

export default App; 